/**
 * 批量上报配置文件
 * @description 批量打点上报方案的配置参数
 */

export const BATCH_CONFIG = {
  // 批量大小：达到此数量触发上报
  batchSize: 3,

  // 最大等待时间（ms）：超过此时间强制上报
  maxWaitTime: 1000,

  // 重试次数：上报失败最大重试次数
  retryTimes: 3,

  // 重试延迟（ms）：首次重试延迟，后续指数增长
  retryDelay: 1000,

  // 队列最大值：内存队列最大容量
  queueMaxSize: 100,

  // 立即上报事件列表：这些事件类型不参与批量，立即上报
  importantEvents: [],

  // 采样率：0-1之间，1表示100%上报
  sampleRate: 1.0,

  // 启用sendBeacon：页面卸载场景使用sendBeacon
  enableBeacon: true,

  // 持久化配置
  storage: {
    // 启用持久化存储
    enabled: true,
    // 存储键名前缀
    keyPrefix: 'bi_batch_',
    // 最大存储数量
    maxStorageSize: 200,
    // 过期时间（ms）：24小时
    expireTime: 24 * 60 * 60 * 1000
  },

  // 监控配置
  monitor: {
    // 启用监控
    enabled: true,
    // 成功率告警阈值
    successRateThreshold: 0.95,
    // 平均延迟告警阈值（ms）
    avgDelayThreshold: 3000,
    // 队列积压告警阈值（百分比）
    queueFullThreshold: 0.8
  }
};

/**
 * 获取配置（支持自定义覆盖）
 * @param {Object} customConfig - 自定义配置
 * @returns {Object} 合并后的配置
 */
export function getBatchConfig(customConfig = {}) {
  return {
    ...BATCH_CONFIG,
    ...customConfig,
    storage: {
      ...BATCH_CONFIG.storage,
      ...(customConfig.storage || {})
    },
    monitor: {
      ...BATCH_CONFIG.monitor,
      ...(customConfig.monitor || {})
    }
  };
}
